module.exports = __webpack_public_path__ + "static/media/facturas.b2032855.svg";